import Box from "@material-ui/core/esm/Box";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EditButton from 'components/Button/EditButton';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import ProfileItem from '../ProfileItem';
import useStyles from '../ProfileStyles';
import BillingEmailDialog from './BillingEmailDialog';
export default function BillingEmail() {
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  const {
    profileRow,
    actionButton
  } = useStyles();
  const [showDialog, setShowDialog] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BillingEmailDialog, {
    open: showDialog,
    onClose: () => setShowDialog(!showDialog)
  }), /*#__PURE__*/React.createElement("div", {
    className: profileRow
  }, /*#__PURE__*/React.createElement(ProfileItem, {
    label: t('email.billing_email'),
    value: customer?.receiveInvoicesByEmail ? customer?.billingEmail : t('email.not_receiving_invoices')
  }), /*#__PURE__*/React.createElement(Box, {
    pb: 0.5
  }, /*#__PURE__*/React.createElement(EditButton, {
    onClick: () => setShowDialog(!showDialog),
    className: actionButton
  }, t('buttons.edit')))));
}